import EntityModel from '@/common/models/entity-model';

export default class CreateKeapInfusionsoftOrderModel extends EntityModel {
    hydrate({
        name = null,
        orderBody = null,
        contactBody = null,
        credentialHash = null,
    } = {}) {
        this.name = name;
        this.orderBody = orderBody;
        this.contactBody = contactBody;
        this.credentialHash = credentialHash;
    }

    getPayload() {
        return {
            name: this.name,
            orderBody: this.orderBody,
            contactBody: this.contactBody,
            credentialHash: this.credentialHash,
        };
    }
}
